import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as PaymentsReceivedService from '../../../services/api/payment_received';
import * as NotificationService from '../../../services/api/notification';
import * as RequestInformation from '../../../services/api/info_request';

class FetchPaymentsReceivedList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: PaymentsReceivedService.FetchPaymentsReceivedListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await PaymentsReceivedService.fetchPaymentsReceivedList(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcReminderList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchUnreadNotificationCount implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Failed,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchUnreadNotificationCount();
        dispatch(this.onSuccess(response.data.total));
      } catch (error: any) {
        // console.log('FetchUnreadNotificationCount Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ClearUnreadNotificationCount implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

class FetchMemberStateCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState();
        //console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        // console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class AllocatePaymentReceived implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ALLOCATE_PAYMENT_RECEIVED,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_ALLOCATE_PAYMENT_RECEIVED,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ALLOCATE_PAYMENT_RECEIVED,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: { paymentReceivedId: number }): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await PaymentsReceivedService.allocateReceivedPayment(payload);
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('AllocatePaymentReceived Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchMemberStateCountriesAction: () =>
    new FetchMemberStateCountries().action(),
  fetchPaymentsReceivedListAction: (
    payload: PaymentsReceivedService.FetchPaymentsReceivedListInput
  ) => new FetchPaymentsReceivedList().action(payload),
  fetchUnreadNotificationCountAction: () =>
    new FetchUnreadNotificationCount().action(),
  clearUnreadNotificationCountAction: () =>
    new ClearUnreadNotificationCount().action(),
  allocatePaymentsReceivedAction: (payload: { paymentReceivedId: number }) =>
    new AllocatePaymentReceived().action(payload),
};
